import * as React from 'react';
import { useEditorContext } from 'ui-components/RichTextEditor/tiptap/editor_context';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUpToLine } from '@fortawesome/pro-regular-svg-icons';
import { MenuItem } from '@chakra-ui/react';
import { useLocalization } from '~/framework';

export const TopAlignButton = () => {
   const { _js } = useLocalization();
   const { editor } = useEditorContext();

   return (
      <MenuItem
         onClick={() => editor.chain().focus().setVerticalAlign('top').run()}
         isDisabled={editor.isActive({ verticalAlign: 'top' })}
         icon={<FontAwesomeIcon icon={faArrowUpToLine} size="lg" />}
         title={_js('Top Align')}
         iconSpacing={0}
      ></MenuItem>
   );
};
